<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{
              `${this.$t("securityguard.edit.title")}`
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("securityguard.edit.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6" class="">
                  <input
                    type="file"
                    name="profile_pic"
                    @change="changeFile($event)"
                    ref="profile_pic"
                    hidden
                  />
                  <v-badge bordered bottom overlap offset-x="20" offset-y="20">
                    <template v-slot:badge>
                      <v-icon
                        small
                        dark
                        @click="openFileExplorer"
                        class="edit-icon"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                    <v-avatar
                      size="120"
                      v-if="securityguard.profile_url != null"
                      class="cursor-pointer imagePreviewWrapper"
                      @click="openFileExplorer"
                    >
                      <img
                        :src="
                          API_BASE_URL + '/uploads/' + securityguard.profile_url
                        "
                        :alt="securityguard.profile_url"
                        v-if="!previewImage"
                      />
                      <img
                        :src="previewImage"
                        :alt="securityguard.profile_url"
                        v-if="previewImage"
                      />
                    </v-avatar>
                    <v-avatar
                      v-if="securityguard.profile_url == null"
                      color="secondary"
                      class="white--text cursor-pointer imagePreviewWrapper"
                      :style="{
                        backgroundImage: `url(${previewImage})`,
                        backgroundSize: 'contain',
                      }"
                      size="120"
                      @click="openFileExplorer"
                    >
                    </v-avatar>
                  </v-badge>
                </v-col>
              </v-row>
              <span
                :class="`${
                  serverSideErrors.profile_pic ? 'red--text' : 'grey--text'
                }`"
                :style="{ marginBottom: '10px' }"
              >
                {{
                  serverSideErrors.profile_pic
                    ? serverSideErrors.profile_pic
                    : "Only image is allowed"
                }}
              </span>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="securityguard.name"
                    name="name"
                    label="Name"
                    v-validate="'required'"
                    :error="
                      errors.first('name') != null ||
                      serverSideErrors.name != null
                    "
                    :error-messages="
                      errors.first('name') || serverSideErrors.name
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6" class="d-flex">
                  <vue-country-code
                    @onSelect="onSelect"
                    class="custom-country-code-select"
                    :defaultCountry="flag"
                  >
                  </vue-country-code>
                  <v-text-field
                    v-model="securityguard.mobile_no"
                    name="mobileno"
                    label="Contact No"
                    v-validate="'required'"
                    :error="
                      errors.first('mobileno') != null ||
                      serverSideErrors.mobileNo != null
                    "
                    :error-messages="
                      errors.first('mobileno') || serverSideErrors.mobileNo
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="securityguard.email"
                    name="email"
                    label="Email"
                    :error="
                      errors.first('email') != null ||
                      serverSideErrors.email != null
                    "
                    :error-messages="
                      errors.first('email') || serverSideErrors.email
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="saveSecurityGuardDetail"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteDocument(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";

// import moment from "moment";
export default {
  data() {
    return {
      selectedCountryCode: "",

      user: {},
      loading: false,
      serverSideErrors: {},
      securityguard: {
        profile_pic: null,
        name: null,
        mobile_no: null,
        email: null,
        country_code: "",
        countryIso: "",
      },
      delete_id: "",
      deleteDialog: false,
      imageDialog: false,
      base_url: process.env.VUE_APP_API_URL,
      profile_pic: {},
      previewImage: null,
      pageRefreshed: null,
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getSecurityguardDetail();
    this.flag = JSON.parse(localStorage.getItem("flag"));
    if (!localStorage.getItem("pageRefreshed")) {
      window.location.reload();
      localStorage.setItem("pageRefreshed", "true");
    } else {
      localStorage.removeItem("pageRefreshed");
    }
  },
  methods: {
    onSelect(event) {
      this.securityguard.country_code = "+" + event.dialCode;
      this.securityguard.countryIso = event.iso2;
    },
    ...mapMutations("alert", ["setAlert"]),
    removeAllFiles() {
      this.$refs.dropzone.removeAllFiles();
    },
    saveSecurityGuardDetail() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          formData.append("name", this.securityguard.name);
          formData.append("mobileNo", this.securityguard.mobile_no);
          formData.append(
            "email",
            this.securityguard.email ? this.securityguard.email : ""
          );
          formData.append("profile_pic", this.profile_pic);
          formData.append(
            "country_code",this.securityguard.country_code
          );
          formData.append("countryIso", this.securityguard.countryIso);

          _self.$axios
            .put(
              "/societyadmin/securityguard/" + this.securityguard.id,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });

                _self.$router.push({ path: "/societyadmin/securityguard" });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                  console.log(this.serverSideErrors);
                }
              }
            });
        }
      });
    },
    getSecurityguardDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/securityguard/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.securityguard = data.securityguard;
            localStorage.setItem(
              "flag",
              JSON.stringify(_self.securityguard.countryIso)
            );
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    closeDialog() {
      (this.deleteDialog = false), (this.delete_id = "");
    },
    openFileExplorer() {
      this.$refs.profile_pic.click();
    },
    changeFile(e) {
      this.profile_pic = e.target.files[0];
      let input = this.$refs.profile_pic;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
  },
};
</script>

<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
.imagePreviewWrapper {
  width: 120px;
  height: 120px;
  display: block;
  cursor: pointer;
  margin: auto;
  background-size: cover;
  background-position: center center;
}
.custom-country-code-select {
  width: 59px;
  height: 40px;
  margin-top: 3px;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 0;
}
.vue-country-select:focus-within {
  box-shadow: none !important;
}
</style>
